import styled from 'styled-components';

const DetailedInfoStyle = styled.div`
	--infoParagraphMarginTop: var(--sp2-5x);
	--detailedInfoMaxWidth: var(--sp57x);
	--detailedInfoMargin: var(--sp11x) var(--sp12x) 0 0;

	.detailed-info-container {
		display: flex;

		.detailed-info-content {
			max-width: var(--detailedInfoMaxWidth);
			margin: var(--detailedInfoMargin);
			transform: translateY(200px);
			opacity: 0;

			h2 {
				font-size: var(--h2L);
				font-family: var(--futura);
				font-weight: 500;
				color: var(--purple);
				margin-bottom: var(--infoParagraphMarginTop);
			}

			p {
				font-size: var(--h5);
				font-family: var(--futura);
			}
		}

		.detailed-image {
			--proportion: 51.7%;
			transform: translateY(200px);
			opacity: 0;
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeS}) {
		--detailedInfoMaxWidth: var(--sp53x);
		--detailedInfoMargin: var(--sp10x) var(--sp8x) 0 0;
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXS}) {
		--detailedInfoMaxWidth: var(--sp46x);
		--detailedInfoMargin: var(--sp8x) var(--sp8x) 0 0;
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXSMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSize}) {
		--infoParagraphMarginTop: var(--sp2x);
		--detailedInfoMaxWidth: var(--sp37x);
		--detailedInfoMargin: var(--sp4x) var(--sp6x) 0 0;
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) {
		--infoParagraphMarginTop: var(--sp2x);
		--detailedInfoMaxWidth: var(--sp51x);
		--detailedInfoMargin: var(--sp3x) 0 0 0;

		.detailed-info-container {
			flex-direction: column-reverse;

			.detailed-image {
				--proportion: 60%;

				width: 74%;
				margin-left: auto;
			}
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeSMin}) {
		--infoParagraphMarginTop: var(--sp1-5x);
		--detailedInfoMaxWidth: 100%;
		--detailedInfoMargin: var(--sp3x) 0 0 0;

		.detailed-info-container {
			flex-direction: column-reverse;

			.detailed-image {
				--proportion: 78.4%;

				width: 100%;
			}
		}
	}
`;

export default DetailedInfoStyle;
